import { render, staticRenderFns } from "./d2-container-full-bs.vue?vue&type=template&id=53ff50d8"
import script from "./d2-container-full-bs.vue?vue&type=script&lang=js"
export * from "./d2-container-full-bs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports